export type ErrorType = {
  code: number;
  details: string[];
  message: string;
};

export const isErrorType = <T>(obj: T | ErrorType): obj is ErrorType => {
  return (obj as ErrorType).code !== undefined;
};
